import { Injectable } from '@angular/core';
import { ProductServiceInterface } from '@app/models/interfaces/product-service.interface';
import { TaqmanSearchResponseInterface } from '@app/models/responses/taqman-search-response.interface';
import { MicrornaAdvancedProductApiInterface } from '@app/products/microrna/microrna-advanced/models/interfaces/microrna-advanced-product-api.interface';
import { MicrornaAdvancedProductInterface } from '@app/products/microrna/microrna-advanced/models/interfaces/microrna-advanced-product.interface';

@Injectable({providedIn: 'root'})
export class MicrornaAdvancedProductService implements ProductServiceInterface {

    makeProductFromSearchResult(searchResult: TaqmanSearchResponseInterface): MicrornaAdvancedProductInterface[] {

        return searchResult.products.map((product: MicrornaAdvancedProductApiInterface) => {

            const newProduct: MicrornaAdvancedProductInterface = {
                ...product,
                selectedAvailability: product.availability, // preselect
                selectedCatalogNumber: product.defaultCatalogNum, // preselect
                selectedSize: product.defaultSize, // preselect
                taqmanProductID: product.productID // unique ID for the UI
            };

            return newProduct;

        });

    }

}
